import { createSelector } from 'reselect';
import { RootState } from '../../../types';
import { EntityTypes } from 'constants/entities';
import { IEntityReducer } from 'core/reducers/entities';
import { Role } from 'types/domain/role';
import { CoursePermissionType, ICoursePermission } from 'types/domain/permissions';
import { ISession } from 'types/domain/session';
import { ISessionReducer } from 'core/slices/session';

const entity = (state: RootState) => state.entity.present;
const id = (state: RootState, id?) => state.state[EntityTypes.COURSE];
const session = (state: RootState) => state.session;

export const selectCoursePermission = createSelector(
  [entity, id, session],
  (entity: IEntityReducer, id: number, session: ISessionReducer) => {
    switch (session.role) {
      case Role.SUPER_ADMIN:
      case Role.ADMIN:
        return CoursePermissionType.ADMIN;
      case Role.AUTHOR:
      case Role.MANAGER:
        const coursePermission: ICoursePermission = Object.values(entity[EntityTypes.COURSE_PERMISSION]).find(
          (cp: ICoursePermission) => cp.courseId === id && cp.organisationUserId === session.organisationUserId,
        );
        return coursePermission ? coursePermission.type : null;
    }
    return null;
  },
);

export const selectCanEdit = createSelector(
  selectCoursePermission,
  (type: CoursePermissionType) => type && [CoursePermissionType.EDIT, CoursePermissionType.ADMIN].includes(type),
);

export const selectCanShare = createSelector(
  selectCoursePermission,
  (type: CoursePermissionType) => type && [CoursePermissionType.SHARE, CoursePermissionType.ADMIN].includes(type),
);

export const selectCanAdmin = createSelector(
  selectCoursePermission,
  (type: CoursePermissionType) => type && type === CoursePermissionType.ADMIN,
);
